export class Pending {
    id: number;
    name: string;
    active: boolean = true;
    type: string;
    isBillable: boolean;
}
